import { render, staticRenderFns } from "./CollectionManagementItem.vue?vue&type=template&id=aa4c16c2&scoped=true&"
import script from "./CollectionManagementItem.vue?vue&type=script&lang=js&"
export * from "./CollectionManagementItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionManagementItem.vue?vue&type=style&index=0&id=aa4c16c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4c16c2",
  null
  
)

export default component.exports